import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import { v4 as uuid } from 'uuid';

import styles from './Breadcrumbs.module.scss';
import { BreadcrumbsProps } from './interfaces';

const Breadcrumbs = ({
  items = [],
  delimiter = '/',
  isLoading,
  className,
}: BreadcrumbsProps) => {
  return (
    <div
      className={classes([styles.root, className])}
      data-delimiter={delimiter}
    >
      {isLoading && skeleton}
      {!isLoading &&
        items.map((item) =>
          item.link ? (
            <Link to={item.link} key={item.link} className={styles.link}>
              <span>{item.label}</span>
            </Link>
          ) : (
            <span key={item.label} className={styles.link}>
              {item.label}
            </span>
          ),
        )}
    </div>
  );
};

const skeleton = Array.from({ length: 3 }, () => uuid()).map((key) => (
  <span className={styles.link} key={key}>
    <Skeleton className={styles.skeleton} />
  </span>
));

export default observer(Breadcrumbs);
